import { Component, Input } from '@angular/core';
import { TransferItem } from 'ng-zorro-antd/transfer';

@Component({
  selector: 'app-transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.scss'],
})
export class TransferComponent {
  @Input() list: TransferItem[] = [];
  @Input() titles: [string, string] = ['', ''];
  disabled = false;

  /**
   * Passed to nz-transfer as a bare reference, so it must be an arrow function
   * (no `this`) and must tolerate items with a missing title/description —
   * one bad item would otherwise throw inside ng-zorro and kill the search.
   */
  filterOption = (inputValue: string, item: TransferItem): boolean => {
    const needle = String(inputValue ?? '')
      .trim()
      .toLowerCase();
    if (!needle) return true;
    const haystack = `${item?.title ?? ''} ${item?.['description'] ?? ''}`.toLowerCase();
    return haystack.includes(needle);
  };
}
